import axios, { AxiosRequestConfig } from "axios";
import { ADMIN_API_BASE } from "./adminApiConfig";
import { saveAdminSession } from "./adminAuth";

export interface AdminLoginResponse {
  code: number;
  message: string;
  data: {
    accessToken?: string;
    refreshToken?: string;
    user: {
      id?: number;
      email: string;
      role: "admin";
    };
  } | null;
}

const adminLogin = async (
  email: string,
  password: string
): Promise<AdminLoginResponse> => {
  try {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: `${ADMIN_API_BASE}/api/admin/login`,
      headers: { "Content-Type": "application/json" },
      data: { email, password },
    };
    const response = await axios(config);
    const body: AdminLoginResponse = response.data;

    if (
      body.code === 200 &&
      body.data?.user &&
      body.data.accessToken &&
      body.data.refreshToken
    ) {
      saveAdminSession(
        body.data.user,
        body.data.accessToken,
        body.data.refreshToken
      );
    }

    return body;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data?.code) {
      return error.response.data as AdminLoginResponse;
    }

    return {
      code: 500,
      message: "Greška pri prijavi",
      data: null,
    };
  }
};

export default adminLogin;
